const URL = window.URL || window.webkitURL

const setSearchParam = ({ url, name, value = "" }) => {
  if (!url) { return }
  url = new URL(url)
  url.searchParams && url.searchParams.set(name, value)
  return url
}
export default setSearchParam
